var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.touch)?_c('div',{staticClass:"key",class:['key-' + _vm.touch.letter, _vm.touch.pressed || !_vm.touch.active ? 'pressed' : '', _vm.is_vowel ? 'vowel' : '', _vm.is_highlight ? 'highlight' : '']},[_c('span',{staticClass:"letter"},[_c('span',[_vm._v(_vm._s(_vm.touch.letter))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2583ff1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Key.vue
// module id = null
// module chunks = 